module.exports = __webpack_public_path__ + "media/svg/original_light_solo-423b764d.svg";